import { Link } from "react-router-dom";
import { CONTACT } from "@/config/contact";

const FAQS = [
  {
    q: "Do you ship internationally?",
    a: "Right now I ship within the UK only. If you're overseas and really want something, get in touch and I'll see what I can do.",
  },
  {
    q: "Do you offer Click & Collect?",
    a: "Yes — choose free Click & Collect at checkout and pick your order up from the Bude salon. It saves on packaging and postage, which is kinder to the planet too.",
  },
  {
    q: "How do I know which products are right for me?",
    a: "Try The Curl Edit to find products matched to your hair, or get in touch before ordering — I'm always happy to help.",
  },
  {
    q: "What if I have curly hair?",
    a: "You're in exactly the right place. Curly and wavy hair is my speciality, and every product here is chosen with curls in mind.",
  },
  {
    q: "How do I book an appointment?",
    a: "You can book online any time using my booking link.",
  },
  {
    q: "Can I buy gift vouchers?",
    a: "Yes — digital gift vouchers are available on the website. Get in touch and I'll help you sort one out.",
  },
];

export default function FAQPage() {
  return (
    <div className="pt-28 lg:pt-44 pb-16" data-testid="faq-page">
      <section className="max-w-3xl mx-auto px-6">
        <p className="font-accent text-xl text-sunset mb-1">questions</p>
        <h1 className="font-display text-4xl sm:text-5xl tracking-tight mb-8">FAQs</h1>

        <div className="space-y-4">
          {FAQS.map((item) => (
            <div key={item.q} className="bg-white/70 rounded-2xl border border-black/5 p-6" data-testid="faq-item">
              <h2 className="font-display text-lg text-black mb-2">{item.q}</h2>
              <p className="text-charcoal/70 text-sm leading-relaxed">
                {item.a}
                {item.q.startsWith("How do I book") && (
                  <>
                    {" "}
                    <a href={CONTACT.bookingUrl} target="_blank" rel="noopener noreferrer" className="text-olive underline underline-offset-2">Book here</a>.
                  </>
                )}
                {item.q.startsWith("How do I know") && (
                  <>
                    {" "}
                    <Link to="/curlscan" className="text-olive underline underline-offset-2">Try The Curl Edit</Link>.
                  </>
                )}
              </p>
            </div>
          ))}
        </div>

        <p className="text-charcoal/60 text-sm mt-8 text-center">
          Still have a question? <Link to="/work-with-me" className="text-olive underline underline-offset-2">Get in touch</Link> — I'd love to help.
        </p>
      </section>
    </div>
  );
}
